<app-homepage-header pageName="{{'home-page-content.all_products' | translate}} "></app-homepage-header>

<section class="section-wrapper all-products-lg">
  <div class="all-products-bg-wrapper">
    <img src="assets/all-products/bg.png" alt="background" class="all-products-bg">
  </div>

  <div class="container all-products-container position-relative">
    <span class="all-products-title mb-2 ">{{'home-page-content.all_products' | translate}}</span>
    <div class="row mt-4 mb-4">
      @for (productCard of products; track productCard) {
        <div class="col-12 col-sm-6 col-md-4 col-lg-4 d-flex">
        <app-product-card class="mb-4 width-100" [productCard]="productCard"></app-product-card>
              </div>
      }
      @if (isLoading && pageSize < totalPageCount - 1) {
        <div class="nav-more mt-20px">
          <div class="d-flex justify-content-center mt-4 flex-direction-row gap-10px">
            <button class="load-history-button">{{ 'my_team.load_more' | translate }}</button>
            <div class="search-loader">
              <div class="spinner-border" role="status">
                <span class="visually-hidden">Loading...</span>
              </div>
            </div>
          </div>
        </div>
      }
    </div>
  </div>
</section>

<app-footer></app-footer>
